import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";

import Table from "react-bootstrap/Table";

import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";

import {
  Grid,
  Segment,
  Accordion,
  Pagination,
  Divider,
  Reveal,
  Menu,
  Label,
  Header,
  Modal,
  Form,
  Step,
  Button,
  Icon,
  Input,
  Message,
  List,
  Checkbox,
} from "semantic-ui-react";
import DateTime from "react-datetime";
import { API_BASE_URL } from "../utils/endpoints";

const commaNumber = require("comma-number");
const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

var yesterday = DateTime.moment().subtract(1, "day");
var valid = function(current) {
  return current.isAfter(yesterday);
};

class IntegrationSMS extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      collapsed: false,
      collapseID: "",
      data: [],
      Details: [],
      job_id: "",
      totalpage: 1,
      activePage: 1,

      searchbulktotalpage: 1,
      searchbulkactivePage: 1,

      exportFalg:false,

      isLoading: true,
      isArabic: false,
      isOperator: true,

      fromDate: "",
      toDate: "",
      modalOpenFilterDetails: false,
      filterTotalpage: 1,

      totalMessages: 0,
      totalRecipient: 0,

      fromDate: "",
      toDate: "", 
      modalOpenFilterDetails: false,
      filterTotalpage: 1,
      modalOpenBulkEdit: false,
      displayViewBox:false
    };
  }


  
  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

  handleOpenViewDetails = () => this.setState({ modalOpenViewDetails: true });
  handleCloseViewDetails = () => this.setState({ modalOpenViewDetails: false });



  /******************************** Fast Track 11/7/2023 *************************************/
  onChangeFromDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();
    console.log(datevalue);
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
   // const month = date.toLocaleString("default", { month: "short" });
   var month = date.getMonth()
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    console.log(time)
    
    if(
      month+1<10
    ){
      month= month+1
      month = '0'+month
    }

    var timees = time.split(":");
    var time_1 =timees[0];
    console.log(time_1)

    if(timearray[1]=="PM"){
      time_1=Number(time_1)+12

      if(time_1=='12'){
        time_1='12'
      }

    }else if(timearray[1]=="AM"){
        if(time_1=='12'){
          time_1='00'
        }
    }

   // const fromDate =  year +"-"+ month +"-" +day +   " " + time_1+":"+timees[1]+":"+timees[2];
   const fromDate =  year +"-"+ month +"-" +day +   " " + "00"+":"+"00"+":"+"00";

    console.log(fromDate,'fromDate')
    this.setState({ fromDate: fromDate });
  };

  onChangeToDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();
    
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    //const month = date.toLocaleString("default", { month: "short" });
    var month = date.getMonth()
    const timevalue = date.toLocaleTimeString();
    console.log(timevalue,'time')
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    console.log(timearray[0],'array0')
    console.log(timearray[1],'array1')
    if(
      month+1<10
    ){
      month= month+1
      month = '0'+month
    }

  
    var timees = time.split(":");
    var time_1 =timees[0];
    console.log(time_1)

    if(timearray[1]=="PM"){
      time_1=Number(time_1)+12

      if(time_1=='12'){
        time_1='12'
      }

    }else if(timearray[1]=="AM"){
        if(time_1=='12'){
          time_1='00'
        }
    }
    

    //const toDate = year +"-"+ month +"-" +day +  " " + time_1+":"+timees[1]+":"+timees[2];
    const toDate = year +"-"+ month +"-" +day +  " " + "00"+":"+"00"+":"+"00";

       console.log(toDate,'        toDate')
    this.setState({ toDate: toDate });
  };

filterData() {
  this.setState({ modalOpenFilterDetails: false });
  var token = reactLocalStorage.get("accessToken");
  var page_num = this.state.activePage - 1;
  var data = {
    
    fromDate: this.state.fromDate,
    toDate: this.state.toDate,
    
  };

  var ip = API_BASE_URL;

  var s2 = "localhost:3000";
  var apiBaseUrl;
  if (ip.includes(s2)) {
    apiBaseUrl =
   API_BASE_URL + "/core/user/rest/jobs/searchIntegrationJob"
     
  } else {
    apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchIntegrationJob"
  }
  var headers = { "Content-Type": "application/json", token: token,
  user_id  : reactLocalStorage.get("user_id_login") ,
  page : 0 }
    

  axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
    const data = res.data.result;
   

    var total = Math.ceil(res.data.result.messages_count / 20);

    console.log(total);
    this.setState({ bulktotalpage: total });

    if (res.data.result.ErrorDescription === "user is not authenticated") {
      window.location = "/app/";
    }

    if (res.data.result.jobDetails != undefined) {
      const data = res.data.result.jobDetails;
      this.setState({ data: data });
      this.setState({ isLoading: false });
      document.querySelector(".searchbulkpagination").style = "display:none";
      document.querySelector(".bulkpagination").style = "display:none";
      document.querySelector(".filterpagination").style = "display:block";
    }
  //   var i, j;

  //   var array = [];

  //   for (i = 0; i < data.length; i++) {
  //     var d = new Date(data[i].schedule_date),
  //       dformat =
  //         [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
  //         " " +
  //         [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
  //     array.push({ date: dformat });
  //   }
  //   this.setState({ date_format: array });
   });
}

handlePaginationFilterChange = (e, { activePage }) => {
  this.setState({ activePage });
  var token = reactLocalStorage.get("accessToken");
  var page_num = this.state.activePage - 1;
  var data = {
    
    fromDate: this.state.fromDate,
    toDate: this.state.toDate,
 
  };

  var ip = API_BASE_URL;

  var s2 = "localhost:3000";
  var apiBaseUrl;
  if (ip.includes(s2)) {
    apiBaseUrl =
   API_BASE_URL + "/core/user/rest/jobs/searchIntegrationJob"
     
  } else {
    apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/searchIntegrationJob"
  }

  var headers = { "Content-Type": "application/json", token: token,
  user_id  : reactLocalStorage.get("user_id_login") ,
  page : 0 }
  axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
    const data = res.data.result;

    var total = Math.ceil(res.data.result.count / 20);
    this.setState({ filterTotalpage: total });
    let result = res.data.result.result;

    if (res.data.result.ErrorDescription === "user is not authenticated") {
      window.location = "/app/";
    }

    if (res.data.result.jobDetails != undefined) {
      const data = res.data.result.jobDetails;
      this.setState({ data: data });
      this.setState({ isLoading: false });
    }
    var i, j;

    // var array = [];

    // for (i = 0; i < data.length; i++) {
    //   var d = new Date(data[i].schedule_date),
    //     dformat =
    //       [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
    //       " " +
    //       [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    //   array.push({ date: dformat });
    // }
    // this.setState({ date_format: array });
  });
};

  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".yellow_color").style =
        "float:right;white-space: pre;";
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        document.querySelector(".search_web ").style =
          "margin-right: 57%; margin-top: 1%;";
      } else {
      }
      document.querySelector(".fixed_bulk").style =
        "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/loadbytokken";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/loadbytokken";
    }

    var headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorResutl) {
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: res.data.result.ErrorResutl,
          animation: "bounce",
          time: 5000,
        });
        window.location = "/app/";
      } else {
        reactLocalStorage.set("user_email", res.data.result.email);
      }
    });

    var token = reactLocalStorage.get("accessToken");
    var page_num = this.state.activePage - 1;
    var data = { searchQuery: "", page: page_num };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/${reactLocalStorage.get(
        "user_id_login"
      )}/0/getIntegrationJob`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/jobs/${reactLocalStorage.get(
          "user_id_login"
        )}/0/getIntegrationJob`;
    }
    var headers = { "Content-Type": "application/json", token: token };

    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const data = res.data.result.jobDetails;

      if(res.data.result.ErrorDescription ==="no integration job was found for this user"){
        this.setState({exportFalg:false})
      }
      else{this.setState({exportFalg:true})}
        
      var total = Math.ceil(res.data.result.messages_count / 20);

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobDetails != undefined) {
        const data = res.data.result.jobDetails;
        this.setState({
            data: data,
            totalMessages: res.data.result.total_messages,
            totalRecipient: res.data.result.total_recipients,
            job_id: res.data.result.job_id,
          });
          var total = Math.ceil(res.data.result.total_messages / 20);
          console.log(total,"total")

          this.setState({ totalPages: total });

         this.setState({ isLoading: false });
      }
    });
  }

 
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    //window.scrollTo(0, 0);
    var token = reactLocalStorage.get("accessToken");
    var data1 = { searchQuery: "", page: activePage - 1 };
    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/${reactLocalStorage.get(
        "user_id_login"
      )}/${activePage - 1}/getIntegrationJob`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/user/rest/jobs/${reactLocalStorage.get(
          "user_id_login"
        )}/${activePage - 1}/getIntegrationJob`;
    }
    var headers = { "Content-Type": "application/json", token: token };

    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      const data = res.data.result.jobDetails;

      if(res.data.result.ErrorDescription ==="no integration job was found for this user"){
        this.setState({exportFalg:false})
      }
      else{this.setState({exportFalg:true})}
        
      var total = Math.ceil(res.data.result.messages_count / 20);

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }

      if (res.data.result.jobDetails != undefined) {
        const data = res.data.result.jobDetails;
        this.setState({
            data: data,
            totalMessages: res.data.result.total_messages,
            totalRecipient: res.data.result.total_recipients,
            job_id: res.data.result.job_id,
          });
          var total = Math.ceil(res.data.result.total_messages / 20);
          console.log(total,"total")

          this.setState({ totalPages: total });

         this.setState({ isLoading: false });
      }
    });
  };

  exportDetalis = (e) => {
    setInterval(this.export_details(), 3000);
   
  };

  export_details = (event) => {
    var x = this;
    x.setState({
      ViewBoxDetails:true
    })
    console.log(idRecord,"idRecord")
    var idRecord = this.state.job_id;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_job_" + idRecord;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            x.export_detailsInterval();
            x.setState({
              ViewBoxDetails:true
            })
            x.setState({ viewData: response.data.status });
          } else if (response.data.status === "ready to download") {
            x.setState({ viewData: response.data.status });

            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
            x.setState({
              ViewBoxDetails:false
            })
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  export_detailsInterval = (event) => {
    var x = this;
    var idRecord = this.state.idRecord;
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_job_" + idRecord;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" + collectionName;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    var callexport = setInterval(function() {
      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              x.setState({
                ViewBoxDetails:true
              })
              x.setState({ viewData: response.data.status });
            } else if (response.data.status === "ready to download") {
              clearInterval(callexport);
              x.setState({ viewData: response.data.status });

              var collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
              x.setState({
                ViewBoxDetails:false
              })
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 3000);
  };

  searchchangemain = (event) => {
    this.setState({ searchWord: event.target.value });
    if (event.target.value.length >= 2) {
      document.querySelector(".bulkpagination").style = "display:none";
      document.querySelector(".searchbulkpagination").style = "display:block";
      var token = reactLocalStorage.get("accessToken");
      var page_num = 0;
     

      var ip = API_BASE_URL;

      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
         API_BASE_URL + `/core/user/rest/jobs/${reactLocalStorage.get("user_id_login")}/0/${event.target.value}/searchIntegrationNumber`
      } else {
        apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/${reactLocalStorage.get("user_id_login")}/0/${event.target.value}/searchIntegrationNumber`;
      }

      var headers = { "Content-Type": "application/json", token: token,
     };
      axios.get(apiBaseUrl,  { headers: headers }).then((res) => {
      
        var total = Math.ceil(res.data.result.messages_count / 20);

        this.setState({ searchbulktotalpage: total });

        let result = res.data.result.jobDetails;

        if (res.data.result.ErrorDescription === "user is not authenticated") {
          window.location = "/app/";
        }

        if (res.data.result.jobDetails != undefined) {
          this.setState({ data: result });
        
        }
      
      });
    }
    if (event.target.value === "") {
      document.querySelector(".bulkpagination").style = "display:block";
      document.querySelector(".searchbulkpagination").style = "display:none";
      this.componentDidMount()
    }
  };

  handlePaginationChangeSearchBasic = (e, { activePage }) => {
    this.setState({ activePage });

    //document.querySelector(".view_basic").style = "display:none";
    //document.querySelector(".view_search_basic").style = "display:block";
    var token = reactLocalStorage.get("accessToken");
    var page_num = activePage - 1;
    var data = { searchQuery: this.state.searchWord, page: page_num ,service_type:"integration_sms" };

    var ip = API_BASE_URL;

    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
       API_BASE_URL + `/core/user/rest/jobs/${reactLocalStorage.get("user_id_login")}/${page_num}/${this.state.searchWord}/searchIntegrationNumber`
    } else {
      apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/${reactLocalStorage.get("user_id_login")}/${page_num}/${this.state.searchWord}/searchIntegrationNumber`;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl,  { headers: headers }).then((res) => {
      const data = res.data.result;
      var total = Math.ceil(res.data.result.messages_count / 20);

      this.setState({ searchbulktotalpage: total });

      let result = res.data.result.result;

      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }

      if (res.data.result.jobDetails != undefined) {
        this.setState({ data: res.data.result.jobDetails });
        
      }
     
    });
  };

  

  render() {
    const styles = {
      container: {
        border: "1px solid #ddd",
        padding: "5px",
        borderRadius: "5px",
      },

      items: {
        display: "inline-block",
        padding: "2px",
        border: "1px solid blue",
        fontFamily: "Helvetica, sans-serif",
        borderRadius: "5px",
        marginRight: "5px",
        cursor: "pointer",
      },

      input: {
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Helvetica, sans-serif",
        width: " 520px !important",
      },
      items2: {
        display: "inline-block",
        padding: "2px",
        border: "1px solid blue",
        fontFamily: "Helvetica, sans-serif",
        borderRadius: "5px",
        marginRight: "5px",
        cursor: "pointer",
      },

      input2: {
        outline: "none",
        border: "none",
        fontSize: "14px",
        fontFamily: "Helvetica, sans-serif",
        width: " 520px !important",
      },
    };
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_bulk">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style yellow_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>

                  <br />
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="mail outline" color="black" /> Integrated SMS{" "} 
                  </Header>{" "}
                </Divider>
                <br />

                <div className="buttonsHeader">
              <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن رقم الهاتف "
                        : "Search By PhoneNumber"
                    }
                    color="black"
                    onChange={this.searchchangemain.bind(this)}
                    style={{ float: "right" }}
                  /> 
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    disabled={this.state.exportFalg === false ? true:false }
                    size="small"
                    onClick={this.exportDetalis}
                  >
                    <Icon name="file excel" /> {i18n.t("export.label")}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon
                      name="sort amount up"
                      onClick={this.handleOpenFilterDetails}
                    />{" "}
                    {i18n.t("filter.label")}
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentDidMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>

              <Button.Group>
                <Button  color="black" basic  >
                <Icon name="mail" />
                {this.state.isArabic ? "مجموع الرسائل" : "Total Messages"}
                </Button>
                <Button  color="black" >
                {this.state.totalMessages}
                </Button> 
              </Button.Group>
             {"  "}
              <Button.Group>
              <Button  color="black" basic  >
                <Icon name="users" />
                {this.state.isArabic  ? "مجموع مستلمين الرسائل" : "Total Recipients"}
                </Button>
                <Button  color="black" >
                {this.state.totalRecipient}
                </Button> 
              </Button.Group>
                 {/*  <Menu compact>
                    <Menu.Item>
                      <Icon name="mail" />{" "}
                      {this.state.isArabic ? "مجموع الرسائل" : "Total Messages"}
                      <Label color="teal" floating>
                        {this.state.totalMessages}
                      </Label>
                    </Menu.Item>
                    <Menu.Item>
                      <Icon name="users" />
                      {this.state.isArabic
                        ? "مجموع مستلمين الرسائل"
                        : "Total Recipients"}
                      <Label color="teal" floating>
                        {this.state.totalRecipient}
                      </Label>
                    </Menu.Item>
                  </Menu> */}
                </div>

                {this.state.ViewBoxDetails && <div className="viewDetails" >
                    <Message icon className="download_details_box">
                      <Icon name="circle notched" loading />
                      <Message.Content>
                        <Message.Header>Wait for downloading</Message.Header>
                        {this.state.viewData}
                      </Message.Content>
                    </Message>
                  </div>}

                <br />
                <br />

               

                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head" colspan="8">
                    <tr>
                      <td> {i18n.t("SMScontent.label")} </td>
                      <td>{i18n.t("sender_id.label")} </td>
                      <td>{i18n.t("recipients.label")} </td>

                      <td> {i18n.t("Status.label")} </td>
                      <td> {i18n.t("Schedule_date.label")}</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((person) => (
                      <tr>
                        <td> {person.message_Content} </td>
                        <td>{person.sender_id}</td>
                        <td> {person.reciepint_number}</td>

                        <td>{person.delivery_status}</td>
                        <td collapsing>{person.send_time}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <br />
                <br />
                <div
                  className="searchbulkpagination"
                  style={{ display: "none" }}
                >
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChangeSearchBasic}
                        totalPages={this.state.searchbulktotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>


                <div className="bulkpagination">
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.totalPages}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
                
                <div className="filterpagination" style={{ display: "none" }}>
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationFilterChange}
                        totalPages={this.state.filterTotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
              </Segment>
            </div>

           
           
          </div>

          <br />
          <br />

          <SemanticToastContainer />
        </div>

        <Modal
            open={this.state.modalOpenFilterDetails}
           
            className="add"
            style={this.state.isArabic ? filtera : filter}
          >
            <Header content="Filter" icon="sort amount up"  />
            <Modal.Content scrolling>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                {i18n.t("start_date.label")}
              </label>
              <br />
              {/*type="datetime-local"*/}
              <input
                type="date"
                onChange={this.onChangeFromDate}
                className="dateinput"
              />

              <br />

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                <br />
                {i18n.t("end_date.label")}
              </label>
              <input
                 type="date"
                onChange={this.onChangeToDate}
                className="dateinput"
              />

              <br />
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={() => {
                  this.filterData();
                }}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseFilterDetails}
              />
            </Modal.Actions>
          </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(IntegrationSMS);
